module.exports = __webpack_public_path__ + "img/3.73df11dd.svg";